<section class="comuniones">
    <div class="container">
        <h1 class="section-tit1">{{titulo}}</h1>
        <div class="intro">
            <div class="intro-cont">
                <div>
                    <neo-span-inner-html [contenido]="texto"></neo-span-inner-html>
                    <a class="btn btn-primary" [routerLink]="pathContacto" title="">
                        Más información
                    </a>
                </div>
            </div>
            <div class="intro-img">
                <picture>
                    <img [src]="imagen['ruta']" [alt]="imagen['alt']"/>
                </picture>
            </div>
        </div>
        <div class="extras">
            <h2 class="section-tit2">Servicios extras</h2>
            <div class="row">
                <div class="col-lg-3 col-sm-4 col-6" *ngFor="let extra of extras">
                    <picture>
                        <img [title]="extra.title" [alt]="extra.alt" [src]="extra.rutaAbsoluta" />
                    </picture>
                    <h3>{{extra.nombrePublico}}</h3>
                </div>
            </div>
        </div>
    </div>
</section>

<neo-bottom-cta [queryParamsFaq]="'0'"></neo-bottom-cta>